import React from 'react';
import { Button, Toast, Tabs } from 'antd-mobile';
import styles from './CrfContent.module.scss';
import CRFComponent from '../../component/crf';
import config from '../../component/config.json';
import backBtn from '../../static/icon/backBtn.svg';

let env = process.env.REACT_APP_ENV;

declare const wx: any;

class CRFContent extends React.Component<any, any> {
  CrfRef: React.RefObject<any>;
  constructor(props: any) {
    super(props);
    this.state = {
      params: {
        channel: config.channel,
        crfCode: '',
        crfVersion: '',
        recordCode: '',
        tenantCode: '',

        caseCode: '',
        eventCode: '',
        headers: {},
        projectCode: '',
        userCode: ''
      },
      readonly: false, // true: 只读
      tabs: [],
      selectTabId: '', // 当前选择的tab id
      currentTabIndex: 0, // 当前tabs的索引
      selectTabCode: ''
    };
    this.CrfRef = React.createRef()
  }

  componentWillMount = () => {
    let crf_readonly = sessionStorage.getItem('crf_readonly')
    // 只读
    if (crf_readonly == 'Complete') {
      this.setState({
        readonly: true
      })
    }
  }

  componentDidMount = () => {
    let localStorage_forms = localStorage.getItem('localStorage_forms');
    if (localStorage_forms) {
      let forms = JSON.parse(localStorage_forms);
      let tabs = forms.forms;
      let activeId = forms.activeId;
      let state = forms.state;

      let index;
      if (tabs && tabs.length > 0) {
        index = tabs.findIndex((item: any) => {
          return item.id == activeId;
        })
      }
      this.setState({
        tabs,
        selectTabId: activeId,
        currentTabIndex: index
      })
    }
  }

  componentWillUnmount = () => {
    this.CrfRef.current.unloadApp()
  }

  // 编辑/数据保存
  onSave = (value: any, storage?: any) => {
    this.setState({
      readonly: false
    })
    if (value) {
      // 编辑
      this.CrfRef.current.init(false)
    } else {
      // 暂存
      if (storage == 'storage') {
        this.CrfRef.current.handleSave()
      }
      // 提交保存
      else {
        this.CrfRef.current.handleSubmit()
      }
    }
  }

  // 保存成功
  onSaveSuccess = (value: any) => {
    
    this.setState({
      readonly: true
    })
    this.CrfRef.current.init(true)
    Toast.success('保存成功！')
    console.log("[onSaveSuccess]", value)

    let data = sessionStorage.getItem('toPhotoEditItem')
    if (data) {
      let item = JSON.parse(data)
      this.props.history.push({ pathname: `/checkSubject/${item.subjectCode}?projectType=${item.projectType}` })
    }
    
  }

  //当选择的tab发生变化
  onChangeTab = (tab: any, index: number) => {
    this.setState({
      currentTabIndex: index,
      selectTabId: tab.id,
      selectTabCode: tab.code,
    })
  }

  render() {
    let { params, readonly, tabs, currentTabIndex, selectTabId, selectTabCode } = this.state;
    let crfParams = sessionStorage.getItem('crfParams')
    if (crfParams) {
      params = Object.assign(params, JSON.parse(crfParams))
      // params.recordCode = selectTabId
      // if (selectTabCode != '') {
      //   params.crfCode = selectTabCode
      // }
    }

    return (
      <div className={styles.CrfContent}>
        <div className={styles.crf_content}>
          <CRFComponent
            ref={this.CrfRef}
            params={params}
            onSaveSuccess={(v: any) => this.onSaveSuccess(v)}
            readonly={readonly}
          />

          {/* <Tabs
            tabs={tabs}
            tabBarUnderlineStyle={{ borderColor: '#6287EC' }}
            tabBarBackgroundColor="transparent"
            tabBarInactiveTextColor="#9A9FAB"
            swipeable={false} animated={false}
            page={currentTabIndex}
            renderTabBar={props => <Tabs.DefaultTabBar {...props} page={3} />}
            onChange={(tab, index) => { this.onChangeTab(tab, index) }}
            renderTab={tab => <span>{tab.title}1</span>}
          >
            {
              tabs.map((item: any, index: any) => (
                <div className={styles.crf_content} key={index}>
                  {
                    currentTabIndex == index &&
                    <CRFComponent
                      ref={this.CrfRef}
                      params={params}
                      onSaveSuccess={(v: any) => this.onSaveSuccess(v)}
                      readonly={readonly}
                    />
                  }
                </div>
              ))
            }
          </Tabs> */}
        </div>

        {/* 操作按钮 */}
        {/* <div className={styles.addAction} id="t-suspend-button" >
          <img src={backBtn} alt="back" onClick={() => { this.props.history.go(-1) }} />
        </div>

        <div className={styles.btns_group}>
          <Button type='ghost' onClick={() => this.onSave(readonly, 'storage')} style={{ opacity: readonly ? 0 : 1 }}>{'暂存'}</Button>
          <Button type='primary' onClick={() => this.onSave(readonly)}>{readonly ? '编辑' : '保存'}</Button>
        </div> */}
      </div>
    );
  }
}
export default CRFContent;
